class SpecialOffer {
    init() {
        this.initSpecialOffer();
    }

    initSpecialOffer() {
        let content = document.querySelector('.special-offer');
        let loginDropDown = document.querySelector('.login-dropdown');
        let loginLabel = document.querySelector('.login-label');
        let currentPage = window.location.pathname;
        let navigation = document.querySelector('.js-navigation');

        if (content) {
            let header = document.querySelector('.header');

            let railTrigger = content.querySelector('.special-offer__rail');
            let close = content.querySelector('.special-offer__close');

            const setSpecialOfferPos = () => {
                let headerHeight = header.offsetHeight;

                if (window.outerWidth < 992) {
                    //document.querySelector('main').style.paddingTop = `${content.offsetHeight}px`;
                    let visible = headerHeight + header.getBoundingClientRect().y;
                    visible = visible > 0 ? visible : 0;
                    content.style.top = '0px';

                    // Adjust main
                    setTimeout(() => {
                        if (window.outerWidth < 992) {
                            let headerHeight = header.offsetHeight;
                            document.getElementById('main').style.marginTop = `${headerHeight + 50}px`;

                            // Adjust anchor nav
                            let anchorNavWrapper = document.querySelector('.anchor-nav-wrapper');
                            if (anchorNavWrapper !== null) {
                                anchorNavWrapper.style.top = `${header.offsetHeight}px`;
                            }
                        }
                    }, 250);
                } else {
                    document.querySelector('main').style.paddingTop = 'unset';
                    content.style.top = `${headerHeight + 32}px`;
                }
            };

            railTrigger.onclick = () => {
                content.classList.add('is-expanded');
                loginDropDown.classList.remove('active');
                loginLabel.classList.remove('active');

                // Adjust main
                setTimeout(() => {
                    if (window.innerWidth < 992) {
                        let headerHeight = header.offsetHeight;
                        document.getElementById('main').style.marginTop = `${headerHeight}px`;

                        // Adjust anchor nav
                        let anchorNavWrapper = document.querySelector('.anchor-nav-wrapper');
                        if (anchorNavWrapper !== null) {
                            anchorNavWrapper.style.top = `${header.offsetHeight}px`;
                        }
                    }
                }, 250);
            };
            close.onclick = () => {
                content.classList.remove('is-expanded');

                // Adjust mobile
                if (window.innerWidth < 992) {
                    // Adjust main
                    let headerHeight = header.offsetHeight;
                    document.getElementById('main').style.marginTop = `${headerHeight}px`;

                    // Adjust anchor nav
                    let anchorNavWrapper = document.querySelector('.anchor-nav-wrapper');
                    if (anchorNavWrapper !== null) {
                        anchorNavWrapper.style.top = `${header.offsetHeight}px`;
                    }

                    navigation.style.top = `${headerHeight}px`;
                }
            };
            window.addEventListener('resize', () => {
                setSpecialOfferPos();
            });
            window.addEventListener('scroll', () => {
                setSpecialOfferPos();
            });

            if (currentPage !== '/') {
                content.classList.add('is-expanded');
            }

            setSpecialOfferPos();
        }
    }
}

export default SpecialOffer;

(() => {
    const specialOffer = new SpecialOffer();
    specialOffer.init();
})();
